// extracted by mini-css-extract-plugin
export var column = "_tf-0";
export var divider = "_tf-2";
export var timePicker = "_tf-1";